import Papa from "papaparse";
import { useState } from "react";
import { useSelector } from "react-redux";

import { csvKeysClub } from "../../config/CsvKeys";
import { ShotExtra } from "../../store/Session/SessionModel";
import {
  generateClubGroup,
  getFormattedClubName
} from "../../store/Session/helper/GenerateClubGroup";
import { RootState } from "../../store/store";

import "./style.css";

const CsvClub = (): JSX.Element => {
  const sessionData = useSelector((state: RootState) => state.session);

  const [isFading, setIsFading] = useState(false);

  const generateCsv = () => {
    setIsFading(true);
    let clubs = generateClubGroup(
      sessionData.shots,
      false,
      sessionData.measuringSystem,
      [],
      sessionData.location
    );
    const flatShots: any = clubs.flatMap((club) => club.shots);

    let csvJson = flatShots.map((shot: any) => {
      shot.clubName = getFormattedClubName(shot.clubName);
      let objectToReturn: any = {};
      csvKeysClub[sessionData.measuringSystem].forEach(
        (keyObject: { title: string; key: string }) => {
          objectToReturn[keyObject.title] = keyObject.key
            .split(".")
            .reduce(
              (obj, key) =>
                obj && obj[key as keyof ShotExtra] !== undefined
                  ? obj[key as keyof ShotExtra]
                  : undefined,
              shot
            );
        }
      );
      return objectToReturn;
    });

    // Convert JSON to CSV
    const csvData = Papa.unparse(csvJson);

    var universalBOM = "\uFEFF";
    var a = window.document.createElement("a");
    a.setAttribute(
      "href",
      "data:text/csv; charset=utf-8," +
        encodeURIComponent(universalBOM + csvData)
    );
    a.setAttribute(
      "download",
      sessionData.name && sessionData.name.length
        ? `${sessionData.name}.csv`
        : `${sessionData.location}_${sessionData.measuringSystem}.csv`
    );
    window.document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      setIsFading(false);
    }, 200);
  };
  return (
    <div
      className={`${isFading ? "fade-out" : ""}`}
      onClick={() => generateCsv()}
    >
      <img
        className="icon-export-excel"
        src="/img/fs_csv.svg"
        alt="Export to Excel"
      />
    </div>
  );
};

export default CsvClub;
